import { render, staticRenderFns } from "./alibeyPopup.vue?vue&type=template&id=488da12a&scoped=true"
import script from "./alibeyPopup.vue?vue&type=script&lang=js"
export * from "./alibeyPopup.vue?vue&type=script&lang=js"
import style0 from "./alibeyPopup.vue?vue&type=style&index=0&id=488da12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488da12a",
  null
  
)

export default component.exports